<template>
    <div class="print-config-level" v-if="hasEntries">
        <print-config-question
                v-if="config.type === 'question' && answers.answer && answers.answer !== 'no'"
                :config="config"
                :answers="answers"
                :questionIcon="questionIcon"
                :level="level"
        />
        <print-config-evaluation
                v-else-if="config.type === 'evaluation'"
                :config="config"
                :answers="answers"
                :level="level"
        />
        <print-config-notice
                v-else-if="config.type === 'notice'"
                :config="config"
                :answers="answers"
                :level="level"
        />

        <print-config-level
                v-for="(item, index) in config.children"
                :config="item"
                :answers="answers.children[index]"
                :level="level + 1"
        />
    </div>
</template>

<script>
    import printConfigEvaluation from "@components/pages/print/concrete/print-config-evaluation";
    import printConfigQuestion from "@components/pages/print/concrete/print-config-question";
    import printConfigNotice from "@components/pages/print/concrete/print-config-notice";

    export default {
        name: "print-config-level",
        components: {
            printConfigEvaluation,
            printConfigQuestion,
            printConfigNotice
        },
        props: {
            config: {
                type: Object
            },
            answers: {
                type: Object
            },
            questionIcon: {
                type: String
            },
            level: {
                type: Number
            }
        },
        computed: {
            hasEntries() {
                return this.answers.answer
                    || this.answers.type === 'options'
                    || this.answers.type == 'section'
            }
        }
    }
</script>

<style lang="scss">
    .print-config-level {
        /*border: solid 1px blue;*/
        /*padding: .5rem .25rem*/
    }
</style>